import { Component, OnInit } from '@angular/core';
import { MarcacaoModel } from "../../models/marcacao.model";
import { SharedMarcacaoService } from "../../services/shared-marcacao.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PrintService } from "../../services/print.service";
import { ToastrService } from "ngx-toastr";
import { MedicoModel } from 'src/app/models/medico.model';
import { MedicoService } from 'src/app/services/medico.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrescricaoTemplateModalComponent } from 'src/app/componentes/modal/prescricao-template-modal/prescricao-template-modal.component';

@Component({
  selector: 'app-prescricao',
  templateUrl: './prescricao.component.html',
  styleUrls: ['./prescricao.component.scss']
})
export class PrescricaoComponent implements OnInit {
  protected marcacaoAtual: MarcacaoModel;
  protected prescricaoCopiada: string = '';
  protected prescricao_SafeHtml: SafeHtml | null = null;
  protected prescricao1_SafeHtml: SafeHtml | null = null;
  protected prescricao2_SafeHtml: SafeHtml | null = null;
  protected prescricao3_SafeHtml: SafeHtml | null = null;
  
  public abaAtiva: number = 1;
  protected medicos: MedicoModel[] = [];

  constructor(private sharedMarcacaoService: SharedMarcacaoService,
    private printService: PrintService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
    private medicoService: MedicoService,
    private modalService: NgbModal,
  ) {
    this.marcacaoAtual = new MarcacaoModel();
  }

  ngOnInit() {
    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      this.marcacaoAtual = res ?? new MarcacaoModel();      

      this.abaAtiva = 1;       
      
      this.prescricao1_SafeHtml = this.marcacaoAtual.prescricao ? this.sanitizer.bypassSecurityTrustHtml(this.marcacaoAtual.prescricao) : null;
      this.prescricao2_SafeHtml = this.marcacaoAtual.prescricao_2 ? this.sanitizer.bypassSecurityTrustHtml(this.marcacaoAtual.prescricao_2) : null;
      this.prescricao3_SafeHtml = this.marcacaoAtual.prescricao_3 ? this.sanitizer.bypassSecurityTrustHtml(this.marcacaoAtual.prescricao_3) : null;      
     
      if (this.marcacaoAtual.prescricao) {
         this.prescricao_SafeHtml = this.sanitizer.bypassSecurityTrustHtml(this.marcacaoAtual.prescricao);
      } else {
         this.prescricao_SafeHtml = null;
      }     

      if (this.marcacaoAtual?.seq_Setor) {
        this.carregarMedicos(this.marcacaoAtual.seq_Setor, 'A');
      }
    });

    this.sharedMarcacaoService.prescricaoCopiada.subscribe((prescricao) => {
      this.prescricaoCopiada = prescricao;
    });
  }

  public mudarAba(aba: number) {
    this.abaAtiva = aba;
  }

  private getTextoAbaAtiva(): string {
    if (this.abaAtiva === 1) return this.marcacaoAtual.prescricao || '';
    if (this.abaAtiva === 2) return this.marcacaoAtual.prescricao_2 || '';
    if (this.abaAtiva === 3) return this.marcacaoAtual.prescricao_3 || '';
    return '';
  }

  private setTextoAbaAtiva(novoTexto: string) {
    if (this.abaAtiva === 1) {
      this.marcacaoAtual.prescricao = novoTexto;
      this.prescricao1_SafeHtml = this.sanitizer.bypassSecurityTrustHtml(novoTexto);
    }
    else if (this.abaAtiva === 2) {
      this.marcacaoAtual.prescricao_2 = novoTexto;
      this.prescricao2_SafeHtml = this.sanitizer.bypassSecurityTrustHtml(novoTexto);
    }
    else if (this.abaAtiva === 3) {
      this.marcacaoAtual.prescricao_3 = novoTexto;
      this.prescricao3_SafeHtml = this.sanitizer.bypassSecurityTrustHtml(novoTexto);
    }
  }

  imprimir() {
    const medico = this.marcacaoAtual.corpoClinico?.profissional;
    const numConselho = medico?.num_Conselho;
    const listaHtml = this.geraHtmlMedicos(this.medicos);
    
    const textoParaImprimir = this.getTextoAbaAtiva();

    const medicos = `
    ${listaHtml}
      <div style="padding-left: 240px; font-size: 12px; line-height: 1.4;">
      ${textoParaImprimir}
    </div>
  `;

    this.printService.printHtmlString('Prescrição', this.marcacaoAtual.beneficiario?.nome_Beneficiario,
      medicos, medico, numConselho);
  }

  public copiarPrescricao() {
    const REALIZADO = 6;
    const FINALIZADO = 7;
    
    // 🟢 CORREÇÃO: Copia o conteúdo da aba ativa atual
    const textoParaCopiar = this.getTextoAbaAtiva();

    if ((this.marcacaoAtual.status_Atendimento === FINALIZADO || this.marcacaoAtual.status_Atendimento === REALIZADO) && textoParaCopiar) {

      this.sharedMarcacaoService.setPrescricaoCopiada(textoParaCopiar);
      this.toastrService.success(`Prescrição da Receita ${this.abaAtiva} copiada com sucesso!`, 'Copiado');
      console.log(`Prescrição da Receita ${this.abaAtiva} copiada:`, textoParaCopiar);

    } else {
      this.toastrService.warning('Este botão só pode ser usado em atendimentos FINALIZADOS que contenham prescrição.', 'Atenção');
    }
  }

  public colarPrescricao() {
    const EM_ATENDIMENTO = 5;

    if (this.prescricaoCopiada && this.marcacaoAtual.status_Atendimento === EM_ATENDIMENTO) {

      // 🟢 CORRIGIDO: Agora chamando as funções e variáveis com os nomes corretos!
      const conteudoAbaAtual = this.getTextoAbaAtiva();
      const novoConteudo = conteudoAbaAtual + (conteudoAbaAtual ? '<br><br>' : '') + this.prescricaoCopiada;
      
      this.setTextoAbaAtiva(novoConteudo);

      this.toastrService.success(`Prescrição colada com sucesso na Receita ${this.abaAtiva}!`, 'Sucesso');
      this.sharedMarcacaoService.setPrescricaoCopiada('');

    } else {
      this.toastrService.warning('O botão Colar só está habilitado para o atendimento com status igual à EM ATENDIMENTO.', 'Atenção');
    }
  }
  
  private getRawValueAbaAtual(): string {
    if (this.abaAtiva === 1) return this.marcacaoAtual.prescricao || '';
    if (this.abaAtiva === 2) return this.marcacaoAtual.prescricao_2 || '';
    if (this.abaAtiva === 3) return this.marcacaoAtual.prescricao_3 || '';
    return '';
  }

  private atualizarValorAbaAtual(texto: string) {
    this.setTextoAbaAtiva(texto);
  }

  public format(command: string) {
    document.execCommand(command, false, '');
  }

  public setColor(event: any) {
    const color = event.target.value;
    document.execCommand('foreColor', false, color);
  }

  public setBackground(event: any) {
    const color = event.target.value;
    document.execCommand('hiliteColor', false, color);
  }

  carregarMedicos(seqSetor: number, status: string) {
    this.medicoService.getMedicos(seqSetor, status).subscribe({
      next: (res) => {
        if (!res.success) {
          return;
        }
        this.medicos = (res.data ?? []).flat();
      },
      error: (err) => {
        this.toastrService.error("Erro ao buscar médicos:", err);
      }
    });
  }

  geraHtmlMedicos(medicos: MedicoModel[]): string {
    if (!medicos || medicos.length === 0) return '';

    const itens = medicos.map(m => `
      <div style="margin-bottom: 6px;">
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">
          ${m.nome ?? ''}
        </div>
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">
          ${m.descricao_Especialidade ?? ''}
        </div>
      </div>
  `).join('');

    return `
    <div id="listaMedicos" style="
      position: fixed;
      top: 140px;
      left: 20px;
      width: 200px;
      height: auto;
    ">
      ${itens}
    </div>
  `;
  }

  abrirModalModelos() {
    const numConselho = this.marcacaoAtual.corpoClinico?.profissional?.num_Conselho; 
    
    if(!numConselho) {
        this.toastrService.warning('Não foi possível identificar o CRM do médico para carregar os modelos.');
        return;
    }

    const modalRef = this.modalService.open(PrescricaoTemplateModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.numConselho = numConselho; 
    
    
    modalRef.componentInstance.textoAtual = this.getTextoAbaAtiva();

    modalRef.result.then((result) => {
      if (result && result.acao === 'usar') {

        if (this.marcacaoAtual.isTravada) {
          this.toastrService.warning('Esta consulta já está finalizada. Você pode criar novos modelos, mas não pode alterar o texto atual.', 'Ação Bloqueada');
          return;
        }
        
        const conteudoAtual = this.getTextoAbaAtiva();
        const textoNovo = conteudoAtual + (conteudoAtual ? '<br><br>' : '') + result.conteudo;    
        
        this.setTextoAbaAtiva(textoNovo);
        this.toastrService.success(`Modelo inserido na Receita ${this.abaAtiva}!`);
      }
    }, () => { });
  }
}